import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';
export function FloatingActions() {
  return <div className="fixed bottom-6 left-6 z-50 flex flex-col gap-4" data-id="element-67">
      <a href="https://wa.me/447865795150" target="_blank" rel="noopener noreferrer" className="w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center text-white shadow-lg hover:scale-110 transition-transform duration-300 relative" aria-label="Chat on WhatsApp" data-id="element-68">
        <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" data-id="element-69"></div>
        <MessageCircle className="w-7 h-7 relative z-10" data-id="element-70" />
      </a>

      <a href="tel:07845242803" className="w-14 h-14 bg-gradient-primary rounded-full flex items-center justify-center text-black shadow-lg hover:scale-110 transition-transform duration-300 relative" aria-label="Call Now" data-id="element-71">
        <div className="absolute inset-0 rounded-full bg-[#FF9500] animate-ping opacity-20" data-id="element-72"></div>
        <Phone className="w-6 h-6 relative z-10 fill-black" data-id="element-73" />
      </a>
    </div>;
}